/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useState} from 'react'
import NPTab3Form from '../../../modules/apps/project/components/ProjectNewEdit/NPTab3Form'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../modules/auth'
import { setProjectStatus } from '../../../common/ModalPopup/reducer'
import { toast } from 'react-toastify'
import { getDevisStatus } from '../../../modules/apps/project/core/projetStatus/request'

const NPUseCondition: FC = () => {
  const [enabled, setEnabled] = useState<boolean>(false)
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state?.projectData)
  const {setAuthMessage, logout} = useAuth()
  const dispatch = useDispatch()
  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }
  
  useEffect(() => {
    const loadStatusDevis = async() => {
      setEnabled(false)
      const wsRes = await getDevisStatus(
        pGuid || projectData?.tab1?.data?.Guid || '',
        onAccessLost,
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
        )
      if(wsRes.data.data && wsRes.data.Status) {
         dispatch(setProjectStatus(wsRes.data.data))        
      }
      setEnabled(true)
    }
   if(pGuid || projectData?.tab1?.data?.Guid) {
    loadStatusDevis()
   }
   else {
    setEnabled(true)
   }
  },[pGuid,projectData?.tab1?.data?.Guid])
  return (
    <div>
      <NPTab3Form  enabled={enabled}/>
    </div>
  )
}

export default NPUseCondition
